import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "px-2 py-4 h-full w-full flex flex-col"
};
import { GameSlot } from "@/modules/main-menu/entity";
import { app } from "@/di";
import GameLoader from "@/modules/main-menu/services/GameLoader";
import GameSlotComponent from "@/modules/main-menu/components/GameSlot.vue";
import { Season } from "@/modules/season/entity";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  async setup(__props) {
    let __temp, __restore;
    const props = __props;
    const slots = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      slots.value = await GameSlot.find();
    })), __temp = await __temp, __restore(), __temp);
    const router = useRouter();
    const load = async slot => {
      await Season.unsetCurrent();
      await app.get(GameLoader).load(slot);
      router.replace({
        name: 'index'
      });
    };
    return (_ctx, _cache) => {
      const _component_NEmpty = _resolveComponent("NEmpty");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        "hide-header": "",
        "hide-footer": "",
        back: ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('load_game')), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [slots.value.length === 0 ? (_openBlock(), _createBlock(_component_NEmpty, {
          key: 0,
          description: _ctx.$t('no_saved_games_yet')
        }, null, 8, ["description"])) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(slots.value, slot => {
          return _openBlock(), _createBlock(GameSlotComponent, {
            key: slot.id,
            "game-slot": slot,
            onDeleted: _unref(refresh)
          }, {
            cta: _withCtx(() => [_createVNode(_component_NButton, {
              secondary: "",
              type: "success",
              onClick: $event => load(slot)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('load')), 1)]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 2
          }, 1032, ["game-slot", "onDeleted"]);
        }), 128))])]),
        _: 1
      });
    };
  }
});